<template>
  <div>
    <span v-if="item.hasResult" class="color-success">{{ item.result.true }}</span>
    <span v-else class="color-success">0</span> /
    <span v-if="item.hasResult" class="color-danger">{{ item.result.allCount - item.result.true }}</span>
    <span v-else class="color-danger">0</span>
    <button v-if="item.hasResult" @click="showTestInfo(item.candidate,item.result.testTypeResults)" class="btn  btn--white  btn--square" style="margin-left: 10px" :title="getTranslation('moreInfo')">
      <svg class="btn__icon  btn__icon--sm">
        <use xlink:href="#icon__search"></use>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "TestResultsSwalComponent",
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  methods: {
    showTestInfo(candidate, results) {
      if (!results)
        return results;

      let html = '<ul class="list-group">';

      let totalCount = 0;
      let totalTrue = 0;
      let totalFalse = 0;
      let totalPoint = 0;

      for (let item of results) {

        totalCount += item.count_total;
        totalFalse += (item.count_total - item.count_true);
        totalTrue += item.count_true;
        totalPoint += item.total_point;

        if (item.is_success)
          html += '<li class="list-group-item">';
        else
          html += '<li class="list-group-item bg--accent">';

        html += '<span class="float-left" >';
        html += item.test_type;
        html += '</span>';


        html += '<div class="float-right" >';
        html += '<span class="badge mr-3" >';
        html += item.total_point;
        html += '</span>';
        html += '<span class="text--success" >';
        html += item.count_true;
        html += '</span>';
        html += '/';
        html += '<span>';
        html += '<span class="text--danger" >';
        html += (item.count_total - item.count_true);
        html += '</span>';
        html += '</span>';

        html += '</div>';

        html += '</li>';
      }

      html += '<li class="list-group-item list-group-item-light">';
      html += '<span class="float-left" >';
      html += this.getTranslation('allCount')
      html += '</span>';
      html += '<div class="float-right" >';

      html += '<span class="text-primary text--bold mr-3" >';
      html += totalPoint;
      html += '</span>';

      html += '<span class="text--success" >';
      html += totalTrue;
      html += '</span>';
      html += '/';
      html += '<span>';
      html += '<span class="text--danger" >';
      html += totalFalse;
      html += '</span>';
      html += '</span>';

      html += '</div>';
      html += '</li>';

      html += '</ul>';

      Swal.fire({
        title: candidate.fullName,
        html: html,
        showCloseButton: true,
        focusConfirm: false,
      })
    },
  }
}
</script>

<style scoped>

</style>
